(function () {
  'use strict';

  var CAROUSEL_BREAKPOINT = 990;

  function initTopAvaliacoes(section) {
    if (section.dataset.taInitialized === 'true') return;
    section.dataset.taInitialized = 'true';

    var track = section.querySelector('[data-ta-track]');
    var viewport = section.querySelector('[data-ta-viewport]');
    var nav = section.querySelector('[data-ta-nav]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-ta-item]'));
    var prevButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ta-prev]'));
    var nextButtons = Array.prototype.slice.call(section.querySelectorAll('[data-ta-next]'));
    var currentIndex = 0;

    if (!track || !items.length) return;

    function isCarousel() {
      return window.innerWidth < CAROUSEL_BREAKPOINT;
    }

    function getVisibleCount() {
      if (window.innerWidth < 750) return 1.15;
      return 2.2;
    }

    function getMaxIndex() {
      var visible = getVisibleCount();
      return Math.max(0, Math.ceil(items.length - visible));
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(index, getMaxIndex()));
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getItemStep() {
      if (!items[0]) return 0;
      return items[0].offsetWidth + getGap();
    }

    function updateItemWidths() {
      if (!isCarousel()) {
        section.style.removeProperty('--ta-item-width');
        return;
      }

      var visible = getVisibleCount();
      var gap = getGap();
      var viewportWidth = viewport ? viewport.offsetWidth : section.offsetWidth;
      var fraction = visible - Math.floor(visible);
      var itemWidth = (viewportWidth - gap * fraction) / visible;

      section.style.setProperty('--ta-item-width', itemWidth + 'px');
    }

    function updateTrack() {
      if (!isCarousel()) {
        track.style.transform = '';
        return;
      }

      track.style.transform = 'translateX(-' + currentIndex * getItemStep() + 'px)';
    }

    function updateNav() {
      var carousel = isCarousel() && items.length > 1;
      var disabledPrev = !carousel || currentIndex <= 0;
      var disabledNext = !carousel || currentIndex >= getMaxIndex();

      if (nav) nav.hidden = !carousel;

      prevButtons.forEach(function (button) {
        button.disabled = disabledPrev;
      });

      nextButtons.forEach(function (button) {
        button.disabled = disabledNext;
      });
    }

    function updateMode() {
      section.classList.toggle('is-carousel', isCarousel() && items.length > 1);
    }

    function goTo(index) {
      if (!isCarousel()) return;
      currentIndex = clampIndex(index);
      updateTrack();
      updateNav();
    }

    function refresh() {
      updateMode();
      currentIndex = clampIndex(currentIndex);
      updateItemWidths();
      updateTrack();
      updateNav();
    }

    prevButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    var touchStartX = 0;
    var touchDeltaX = 0;

    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        if (!isCarousel()) return;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      }, { passive: true });

      viewport.addEventListener('touchmove', function (event) {
        if (!isCarousel()) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        if (!isCarousel()) return;
        if (Math.abs(touchDeltaX) < 40) return;
        if (touchDeltaX < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-top-avaliacoes]').forEach(initTopAvaliacoes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-top-avaliacoes]');
    if (section) {
      section.dataset.taInitialized = 'false';
      initTopAvaliacoes(section);
    }
  });
})();
